<style scoped>
button .tooltip {
    display: none;
}

button:hover {
    position: relative;
}

button:hover .tooltip {
    display: block;
    position: absolute;
    left: 0;
    white-space: nowrap;
    @apply bg-white rounded border border-darkGrayishBlue text-darkGrayishBlue p-2;
}
</style>

<template>
    <div v-if="order && order.saleOrdStsCode === 'P'">
        <button
            v-if="!refreshing"
            @click="refreshPaymentStatus"
            class="focus:outline-none"
        >
            <div class="icon text-blue">
                <refresh />
            </div>
            <div class="tooltip">{{ $t('order.status.refresh') }}</div>
        </button>
        <div v-else>
            <spinner class="spinner-sm" />
        </div>
    </div>
</template>

<script>
import spinner from '@/components/spinner.vue';
import refresh from '@/assets/svg/refresh.svg';
import { instance } from '@/utils/ajax';

async function refreshPaymentStatus(saleOrdKey) {
    try {
        let result = await instance.post('/api/payment/refreshPendingPayment', {
            saleOrdKey: saleOrdKey
        });
        return result.data.data.salesOrder;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error refresh payment status');
    }

    return undefined;
}

export default {
    components: { spinner, refresh },
    props: {
        order: { type: Object, required: true }
    },
    data: function() {
        return {
            refreshing: false
        };
    },
    methods: {
        async refreshPaymentStatus() {
            this.refreshing = true;
            const salesOrder = await refreshPaymentStatus(this.order.id);
            if (salesOrder) {
                this.$store.commit('setOrderToOrderList', salesOrder);
                // Refresh Shopping Cart
                if (salesOrder.saleOrdStsCode !== 'P')
                    this.$store.dispatch('getShoppingCartList');
            }
            setTimeout(() => {
                this.refreshing = false;
            }, 800);
        }
    }
};
</script>
